<ng-container *ngIf="anchor">
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="anchor"
    [cdkConnectedOverlayOpen]="open"
    [cdkConnectedOverlayPositions]="positions"
  >
    <div class="pw-reqs" [style.--width]="panelWidth" data-test="pw-reqs">
      <div class="fw-b mb-1 colon" i18n>Password must be</div>

      <div class="vstack gap-_5 mat-small">
        <div
          class="hstack gap-1"
          [ngClass]="{
            'pw-reqs-valid': !(
              control.hasError('minlength') ||
              control.hasError('required') ||
              control.hasError('noSpaces')
            ),
            'pw-reqs-invalid':
              control.hasError('minlength') ||
              control.hasError('required') ||
              control.hasError('noSpaces')
          }"
        >
          <ng-container>
            <div class="pw-reqs-icon-container">
              <mat-icon
                data-test="pw-reqs-invalid-icon"
                svgIcon="close"
                *ngIf="
                  control.hasError('minlength') ||
                    control.hasError('required') ||
                    control.hasError('noSpaces');
                  else validIcon
                "
              ></mat-icon>
            </div>
          </ng-container>
          <span i18n>At least 12 characters with no spaces</span>
        </div>

        <div
          class="hstack gap-1"
          [ngClass]="{
            'pw-reqs-valid': !control.hasError('uppercaseChars'),
            'pw-reqs-invalid': control.hasError('uppercaseChars')
          }"
        >
          <ng-container>
            <div class="pw-reqs-icon-container">
              <mat-icon
                data-test="pw-reqs-invalid-icon"
                svgIcon="close"
                *ngIf="control.hasError('uppercaseChars'); else validIcon"
              ></mat-icon>
            </div>
          </ng-container>
          <span i18n>At least one uppercase character</span>
        </div>

        <div
          class="hstack gap-1"
          [ngClass]="{
            'pw-reqs-valid': !control.hasError('lowercaseChars'),
            'pw-reqs-invalid': control.hasError('lowercaseChars')
          }"
        >
          <ng-container>
            <div class="pw-reqs-icon-container">
              <mat-icon
                data-test="pw-reqs-invalid-icon"
                svgIcon="close"
                *ngIf="control.hasError('lowercaseChars'); else validIcon"
              ></mat-icon>
            </div>
          </ng-container>
          <span i18n>At least one lowercase character</span>
        </div>

        <div
          class="hstack gap-1"
          [ngClass]="{
            'pw-reqs-valid': !control.hasError('numberChars'),
            'pw-reqs-invalid': control.hasError('numberChars')
          }"
        >
          <ng-container>
            <div class="pw-reqs-icon-container">
              <mat-icon
                data-test="pw-reqs-invalid-icon"
                svgIcon="close"
                *ngIf="control.hasError('numberChars'); else validIcon"
              ></mat-icon>
            </div>
          </ng-container>
          <span i18n>At least one number</span>
        </div>

        <div
          class="hstack gap-1"
          [ngClass]="{
            'pw-reqs-valid': !control.hasError('specialChars'),
            'pw-reqs-invalid': control.hasError('specialChars')
          }"
        >
          <ng-container>
            <div class="pw-reqs-icon-container">
              <mat-icon
                data-test="pw-reqs-invalid-icon"
                svgIcon="close"
                *ngIf="control.hasError('specialChars'); else validIcon"
              ></mat-icon>
            </div>
          </ng-container>
          <span i18n>At least one special character from £_-=!&#64;#$%^&*</span>
        </div>

        <div
          class="hstack gap-1"
          [ngClass]="{
            'pw-reqs-valid': !control.hasError('onlyPasswordChars'),
            'pw-reqs-invalid': control.hasError('onlyPasswordChars')
          }"
        >
          <ng-container>
            <div class="pw-reqs-icon-container">
              <mat-icon
                data-test="pw-reqs-invalid-icon"
                svgIcon="close"
                *ngIf="control.hasError('onlyPasswordChars'); else validIcon"
              ></mat-icon>
            </div>
          </ng-container>
          <span i18n>Only contain characters from the list above</span>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #validIcon>
  <mat-icon luiListItemIcon svgIcon="tick"></mat-icon>
</ng-template>
